export default "    <app-translation-selection-list></app-translation-selection-list>"